<template>
  <v-row>
    <!--Empresa Administradora del servicio-->
    <v-col cols="12" sm="12" md="12">
      <v-autocomplete
        v-model="DocumentID"
        :items="ArrayaEmpresaResponsable"
        :item-title="
          (ArrayaEmpresaResponsable) =>
            ArrayaEmpresaResponsable.Document_ID +
            '-' +
            ArrayaEmpresaResponsable.DescNombre
        "
        item-value="Document_ID"
        color="primary"
        label="Empresa que administra el servicio:"
        dense
        clearable
      >
      </v-autocomplete>
    </v-col>
    <v-col cols="10">
      <v-file-input
        show-size
        counter
        v-model="fileUpload"
        accept=".xlsx"
        label="Seleccione el archivo a migrar:"
        clearable
      ></v-file-input>
    </v-col>
    <v-col cols="2">
      <v-btn
        block
        @click="getPostArvhivoAEP()"
        text
        dark
        size="x-large"
        color="green"
      >
        <template v-slot:prepend>
          <v-icon>mdi-content-save</v-icon>
        </template>
        Guardar</v-btn
      >
    </v-col>
  </v-row>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Migracion_Garantias",
  data() {
    return {
      progreso: false,
      fileUpload: null,
      ArrayaEmpresaResponsable: [],
      DocumentID: null,
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Envia Archivo Garantías
    async getPostArvhivoAEP() {
      if (this.fileUpload != null && this.DocumentID != null) {
        this.progreso = true;
        var data = new FormData();
        data.append("empresa", this.DocumentID);
        data.append("archivo", this.fileUpload[0]);
        var userperfil = this.$store.getters.userperfil;
        this.axios
          .post(
            "/ActivosO/MigracionGarantias/CR1/" +
              userperfil.userInfo.Usuario_ID,
            data
          )
          .then((response) => {
            if (response.data == "Exito") {
              this.$swal({
                icon: "success",
                title: "Relación Guardada",
                html: "La información se ha guardado correctamente.",
              });
              this.fileUpload = [];
            }
          })
          .catch((e) =>
            this.$swal({
              icon: "error",
              title: "Error al consultar datos",
              html:
                "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
                e.toString() +
                "</code></small>",
            })
          )
          .finally(() => {
            this.progreso = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "Advertencia al consultar masivo",
          html: "Por favor, Suba un archivo excel con los parametros establecidos. ",
        });
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones //////////////////////////////////////////
    // Consulta Empresa Responsable
    async getEmpresaResponsable() {
      this.ArrayaEmpresaResponsable = [];
      this.axios
        .get("/Personas/Cliente/CD2/9")
        .then((response) => {
          this.ArrayaEmpresaResponsable = response.data;
        })
        .catch((e) => console.log(e));
    },
  },
  mounted() {
    this.getEmpresaResponsable();
  },
};
</script>
